import { render, staticRenderFns } from "./OfficialSite.vue?vue&type=template&id=614d8d72&scoped=true"
import script from "./OfficialSite.vue?vue&type=script&lang=js"
export * from "./OfficialSite.vue?vue&type=script&lang=js"
import style0 from "./OfficialSite.vue?vue&type=style&index=0&id=614d8d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d8d72",
  null
  
)

export default component.exports